import React from 'react';
import phone from 'shared/utils/phone';
import { Input } from 'antd';
import Flag from 'components/Flag';

export const phoneValidator = async (rule, value) => {
  if (value && !phone.parse(value).isValid()) {
    throw new Error();
  }
};

export const validPhoneNumber = { validator: phoneValidator, message: 'Invalid phone number' };

const PhoneInput = ({ value, onChange }) => {
  const number = value ? phone.parse(value) : null;

  const handleChange = e => {
    const { value: newValue } = e.target;
    onChange(phone.parse(newValue)?.number || newValue);
  };

  return (
    <Input type="tel" autoComplete="tel" value={number?.formatInternational() || value} prefix={<Flag countryCode={number?.country} />} onChange={handleChange} placeholder="+46 70 123 45 67" />
  );
};

export default PhoneInput;
